module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_09.5eb4d5ce.png";